import type { FaireProductEntity } from "../../entity_types/product";

export const p_gq9jfwcavr: FaireProductEntity = {
  token: "p_gq9jfwcavr",
  type: "product",
  name: "Women's Soft Printed Slim Notch Collar Pajama Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/f3ec3ada9615252e9eaffdf72442951a21c274df017a150bd7221892c6f2467b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cefcf97105feb9c1ea7246f2171edc7b0b644110105650d2d1017319297529b.png",
    "https://cdn.faire.com/fastly/9a0da191cf5a93a067a8e2d9590e9fa0bb592242733f931b71b2122d7c47ae42.png",
    "https://cdn.faire.com/fastly/013997863c4b2cce7dc29dcde86c010bcedb73578586853b182e41731b2d786e.png",
    "https://cdn.faire.com/fastly/39a5cf498872a41eb77979aa55fececc8316b2a79ad62a016aef6529dc93812b.png",
    "https://cdn.faire.com/fastly/73038548e8cd9198317d5001532ce1ad979de605860efcb516f9949741775963.png",
    "https://cdn.faire.com/fastly/d7f07acae6e15c43fdf2f74110fa8383c0d7e1182facbc699eba3e135601a3d5.png",
    "https://cdn.faire.com/fastly/c747ea3718503cca1e52ca0cd4f4c1e9dbc89e46a21a63325de2dbcb46655011.jpeg",
    "https://cdn.faire.com/fastly/d9b2f5d1ae9a53616dc5e713300d02172404d0ee4f8eede300e6489bb1c5594d.jpeg",
    "https://cdn.faire.com/fastly/7be2630e77d86ba084c052a3ceca0b3ddf3c41a6b0a6261c7c10cce44cd8809a.jpeg",
    "https://cdn.faire.com/fastly/f9fb8aa06e6211e0bbd87bcf48346af5bbb5ce4136dd3ff9c5a1c88631bc05b5.png",
    "https://cdn.faire.com/fastly/f9d77bd1fd043739c0c75f435ad273526d892b1a994d88835300d86e8b8986f4.jpeg",
    "https://cdn.faire.com/fastly/c3fd0c976f3ac1c78ee5bababbc20c2125e5defa421ca1b0c04baa6f9bf97e8f.jpeg",
    "https://cdn.faire.com/fastly/c0f9105788b209495a3d36d387a5e2546af5a331f147ba054b7a2fd442e38f48.jpeg",
    "https://cdn.faire.com/fastly/0c633ce81ac2be2227831195add679721518ac6b1bdf4333b68f62e40ec6de0d.png"
  ],
  priceDollars: 65,
  description: "Thoughtfully designed to elevate your nightly routine, this luxurious pajama set wraps you in buttery-soft comfort from the moment you slip it on. Crafted for restful sleep and slow mornings, the breathable fabric gently drapes over the body with a cooling feel and just the right amount of stretch for unmatched comfort all night long.\n\nFeatures:\n● Slim-fit notch collar top with classic button-front styling\n● Full-length pant with side pockets and adjustable drawstring waistband\n● Breathable, cooling fabric helps keep you comfortable throughout the night\n● 28\" inseam\n\nMaterials & Care:\n● 96% Modal, 4% Spandex\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n● Colorfast, easy-care fabric\n\nBest For:\n● Restful nights and slow mornings\n● Lounging in luxurious comfort\n● Cozy weekends at home\n● Gifting for holidays, birthdays, and special occasions\n",
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:03.367Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
